var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"px-0 mx-0",attrs:{"elevation":"0","min-width":"48","max-width":"48","tile":""},on:{"click":_vm.setLink}},[_c('v-icon',[_vm._v(_vm._s(_vm.icons.mdiLink))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }